package dev.jfronny.zerointerest.db

import androidx.room3.RoomDatabaseConstructor

public actual object ZeroInterestRoomDatabaseConstructor : RoomDatabaseConstructor<ZeroInterestRoomDatabase> {
  actual override fun initialize(): ZeroInterestRoomDatabase = dev.jfronny.zerointerest.db.ZeroInterestRoomDatabase_Impl()
}
